<template>
  <div class="contract-detail-page">
    <div class="detail-card contract-info-card">
      <div class="detail-card-header">
        <div class="breadcrumb-title">
          <span class="breadcrumb-muted breadcrumb-link" @click="goContractQuery()">合同查询</span>
          <span class="breadcrumb-arrow">></span>
          <span class="breadcrumb-muted breadcrumb-link" @click="goContractInfo()">查看合同信息</span>
          <span class="breadcrumb-arrow">></span>
          <span class="breadcrumb-current breadcrumb-link" @click="goBusinessAccept()">业务受理</span>
        </div>
        <el-button size="small" class="figma-btn-back" @click="_goBack()">返回</el-button>
      </div>

      <div class="contract-info-box">
        <div class="contract-info-grid">
          <div v-for="item in contractInfoItems" :key="item.label" class="contract-info-item">
            <span class="info-label">{{ item.label }}：</span>
            <span class="info-value">{{ item.value || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-card contract-tabs-card">
      <el-tabs v-model="pageState._currentTab" class="figma-detail-tabs">
        <el-tab-pane v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name" />
      </el-tabs>

      <component
        :is="pageState._currentTab"
        :ref="pageState._currentTab"
        class="contract-detail-child"
        :contractId="pageState.contractId"
        :contractName="pageState.contractName"
        :ownerId="pageState.ownerId"
      />
    </div>

    <div class="detail-card action-footer-card">
      <div class="footer-actions">
        <el-button size="small" class="figma-btn-cancel" @click="_goBack()">取消</el-button>
        <el-button size="small" type="primary" class="figma-btn-print" @click="_printContract()">打印</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ARoomDetailCar from '@/components/aCommunity/aRoomDetailCar'
import ARoomDetailMember from '@/components/aCommunity/aRoomDetailMember'
import ARoomDetailComplaint from '@/components/aCommunity/aRoomDetailComplaint'
import ARoomDetailRepair from '@/components/aCommunity/aRoomDetailRepair'
import AOwnerDetailAccessControl from '@/components/aCommunity/aOwnerDetailAccessControl'
import { queryContract } from '@/api/contract/contractDetailApi'

// 预留占位子页（可后续替换为真实实现）
const PlaceholderPane = {
  name: 'PlaceholderPane',
  props: ['title'],
  template: '<div style="padding:12px;color:#8C9BB4">{{ title }} 开发中…</div>'
}

export default {
  name: 'ContractQueryDetail',
  components: {
    // 子标签映射（严格顺序：房产、车辆、成员、投诉、报修、人脸同步、预留）
    // 房产：接入合同房屋接口
    房产: () => import('@/components/contract/contractQueryRoom.vue'),
    车辆: ARoomDetailCar,
    成员: ARoomDetailMember,
    投诉: ARoomDetailComplaint,
    报修: ARoomDetailRepair,
    人脸同步: AOwnerDetailAccessControl,
    预留: PlaceholderPane
  },
  data() {
    return {
      pageState: {
        contractId: '',
        contractName: '',
        ownerId: '',
        _currentTab: '房产'
      },
      tabs: [
        { label: '房产', name: '房产' },
        { label: '车辆', name: '车辆' },
        { label: '成员', name: '成员' },
        { label: '投诉', name: '投诉' },
        { label: '报修', name: '报修' },
        { label: '人脸同步', name: '人脸同步' },
        { label: '预留', name: '预留' }
      ],
      contractDetailInfo: {
        contractId: '',
        contractName: '',
        contractCode: '',
        contractTypeName: '',
        partyA: '',
        partyB: '',
        aContacts: '',
        aLink: '',
        bContacts: '',
        bLink: '',
        operatorName: '',
        operatorLink: '',
        contractAmount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        stateName: '',
        objId: '' // 业主ID
      }
    }
  },
  computed: {
    contractInfoItems() {
      const c = this.contractDetailInfo
      return [
        { label: '合同名称', value: c.contractName },
        { label: '合同编号', value: c.contractCode },
        { label: '合同类型', value: c.contractTypeName },
        { label: '甲方', value: c.partyA },
        { label: '甲方联系人', value: c.aContacts },
        { label: '甲方联系电话', value: c.aLink },
        { label: '乙方', value: c.partyB },
        { label: '乙方联系人', value: c.bContacts },
        { label: '乙方联系电话', value: c.bLink },
        { label: '经办人', value: c.operatorName },
        { label: '联系电话', value: c.operatorLink },
        { label: '合同金额', value: c.contractAmount },
        { label: '开始时间', value: c.startTime },
        { label: '结束时间', value: c.endTime },
        { label: '签订时间', value: c.signingTime },
        { label: '状态', value: c.stateName }
      ]
    }
  },
  watch: {
    $route() {
      this.initFromRoute()
    },
    'pageState._currentTab'(newTab, oldTab) {
      if (newTab && newTab !== oldTab) {
        this.$nextTick(() => this._notifyChildOpen())
      }
    }
  },
  created() {
    this.initFromRoute()
  },
  methods: {
    initFromRoute() {
      // 来源：/views/contract/contractQueryDetail?contractId=...&currentTab=...
      const { contractId, currentTab } = this.$route.query
      this.pageState.contractId = contractId || this.$route.params.contractId || ''
      if (currentTab && this.tabs.some(t => t.name === currentTab)) {
        this.pageState._currentTab = currentTab
      } else {
        this.pageState._currentTab = '房产'
      }
      if (this.pageState.contractId) {
        this._loadContractInfo()
      }
    },
    async _loadContractInfo() {
      try {
        const res = await queryContract({ page: 1, row: 1, contractId: this.pageState.contractId })
        const contract = (res.data || [])[0] || {}
        Object.assign(this.contractDetailInfo, contract)
        this.pageState.contractName = contract.contractName || ''
        this.pageState.ownerId = contract.objId || ''
        this.$nextTick(() => this._notifyChildOpen())
      } catch (e) {
        console.error('加载合同信息失败', e)
      }
    },

    _notifyChildOpen() {
      const tab = this.pageState._currentTab
      const ref = this.$refs[tab]
      if (ref && ref.open) {
        ref.open({
          contractId: this.pageState.contractId,
          contractName: this.pageState.contractName,
          ownerId: this.pageState.ownerId
        })
      }
      if (ref && ref.handleSwitch) {
        ref.handleSwitch({
          contractId: this.pageState.contractId,
          contractName: this.pageState.contractName,
          ownerId: this.pageState.ownerId
        })
      }
    },
    goContractQuery() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace('/pages/committee/contractQuery').catch(() => {})
      }
    },
    goContractInfo() {
      const contractId = this.pageState.contractId
      if (!contractId) {
        this.goContractQuery()
        return
      }
      this.$router.push({
        path: '/views/contract/contractDetail',
        query: {
          contractId,
          source: 'contractQuery',
          currentTab: this.$route.query.parentTab || this.$route.query.prevTab || 'contractDetailRoom'
        }
      }).catch(() => {})
    },
    goBusinessAccept() {
      const contractId = this.pageState.contractId
      if (!contractId) return
      this.$router.replace({
        path: `/views/contract/contractQueryDetail/${contractId}`,
        query: {
          source: 'contractQuery',
          currentTab: this.pageState._currentTab,
          parentTab: this.$route.query.parentTab || this.$route.query.prevTab || 'contractDetailRoom'
        }
      }).catch(() => {})
    },
    _goBack() {
      this.goContractQuery()
    },
    _printContract() {
      const id = this.pageState.contractId
      if (!id) {
        this.$message.error('缺少合同ID，无法打印')
        return
      }
      window.open(`/#/views/contract/printContract?contractId=${id}`)
    }
  }
}
</script>

<style scoped>
.contract-detail-page {
  min-height: 100%;
  padding: 20px;
  box-sizing: border-box;
  background: #EBF2FA;
}

.detail-card {
  background: #fff;
  border-radius: 12px;
  box-sizing: border-box;
}

.contract-info-card {
  min-height: 314px;
  padding: 20px 24px 28px;
}

.detail-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 38px;
}

.breadcrumb-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.breadcrumb-muted {
  color: #8C9BB4;
}

.breadcrumb-arrow {
  color: #8C9BB4;
  font-weight: 400;
}

.breadcrumb-current {
  color: #1D2129;
}

.breadcrumb-link {
  cursor: pointer;
  transition: color .2s;
}

.breadcrumb-link:hover {
  color: #0E76FF;
}

.figma-btn-back,
.figma-btn-cancel {
  width: 78px;
  height: 38px;
  padding: 0 !important;
  border-radius: 10px !important;
  border-color: #0E76FF !important;
  color: #0E76FF !important;
  background: #fff !important;
  font-size: 14px !important;
}

.contract-info-box {
  margin-top: 30px;
  padding: 22px 24px;
  min-height: 196px;
  box-sizing: border-box;
  background: #F3F7FB;
  border-radius: 8px;
}

.contract-info-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  column-gap: 48px;
  row-gap: 18px;
}

.contract-info-item {
  min-width: 0;
  display: grid;
  grid-template-columns: 98px minmax(0, 1fr);
  align-items: center;
  font-family: PingFang SC, Microsoft YaHei, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.contract-info-item .info-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-label {
  color: #8C9BB4;
  text-align: right;
}

.info-value {
  color: #1D2129;
}

.contract-tabs-card {
  min-height: 318px;
  margin-top: 16px;
  padding: 18px 24px 24px;
}

.figma-detail-tabs >>> .el-tabs__header {
  margin: 0 0 20px;
}

.figma-detail-tabs >>> .el-tabs__nav-wrap {
  height: 44px;
  overflow: visible;
  border-bottom: 1px solid #EBF2FA;
}

.figma-detail-tabs >>> .el-tabs__nav-wrap::after {
  display: none;
}

.figma-detail-tabs >>> .el-tabs__nav-scroll,
.figma-detail-tabs >>> .el-tabs__nav {
  height: 44px;
  overflow: visible;
}

.figma-detail-tabs >>> .el-tabs__item {
  position: relative;
  height: 44px;
  padding: 0 !important;
  margin-right: 40px;
  color: #1D2129;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.figma-detail-tabs >>> .el-tabs__item.is-active {
  color: #0E76FF;
}

.figma-detail-tabs >>> .el-tabs__item.is-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 2px;
  background: #0E76FF;
}

.figma-detail-tabs >>> .el-tabs__active-bar {
  display: none;
}

.contract-detail-child { display: block; }

.action-footer-card {
  height: 94px;
  margin-top: 16px;
  padding: 28px 24px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.figma-btn-print {
  width: 98px;
  height: 38px;
  padding: 0 !important;
  border-radius: 10px !important;
  border-color: #0E76FF !important;
  background: #0E76FF !important;
  font-size: 14px !important;
}

@media (max-width: 1200px) {
  .contract-info-grid { grid-template-columns: repeat(2, minmax(180px, 1fr)); }
}

@media (max-width: 768px) {
  .contract-detail-page { padding: 12px; }
  .contract-info-card, .contract-tabs-card, .action-footer-card { padding-left: 16px; padding-right: 16px; }
  .contract-info-grid { grid-template-columns: 1fr; row-gap: 16px; }
  .detail-card-header { align-items: flex-start; flex-direction: column; gap: 12px; }
}
</style>
